import { createApiCall } from 'lib/base';

const POST_INVESTCORE_EMPLOYEE_PROGRAM_INVITE_API_ID =
  'DASHBOARD/POST_INVESTCORE_EMPLOYEE_PROGRAM_INVITEL_API';

const apiCall = createApiCall(
  POST_INVESTCORE_EMPLOYEE_PROGRAM_INVITE_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/employee-programs/${id}/invite`,
    method: 'POST',
    isStay: true,
    notify: true,
  })
);

export default apiCall;
